<template>
  <div class="login">
    <div class="login-title">
      <img src="../../assets/images/login/login-title.png" />
    </div>
    <div class="login-content" v-if="!user">
      <!-- 账号密码登录 -->
      <div class="login-box accont-box">
        <div class="wx-text">帐号登录</div>
        <div class="input-box">
          <a-input class="accont-input" size="large" v-model:value="account" placeholder="请输入帐号" />
          <form action>
            <a-input-password class="password-input" size="large" v-model:value="password" placeholder="请输入密码"
              autocomplete="“off”" />
          </form>
        </div>
        <div class="login-button-box">
          <a-button class="login-button" size="large" type="primary" @click="login" :loading="logining">登录</a-button>
        </div>
      </div>
      <!-- 扫码登录 -->
      <div class="login-box wx-box">
        <div class="wx-text">扫码登录</div>
        <div id="wx-login-qrCode"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { PASSPORT_SERVER, LESSONPLAY_TOKEN, ONLINE_URL } from '../../config/url';
import { PC_APPID, SCOPE } from '../../config/wx';
import headPath from '@/filter/headPath';

export default {
  name: "login",
  data() {
    return {
      loading: true,
      logining: false,
      account: '',
      password: '',
      user: null
    }
  },
  async mounted() {
    this.user = this.$store.state.userInfo;
    this.wxloginForPC();
    this.getClassOfUser();
  },
  methods: {
    //获取某用户所有班级
    async getClassOfUser() {
      let user = this.user;
      if (!user) return;

      this.loading = false;
      this.logining = false;
      this.$router.push(`/classList`);
    },
    //生成登录二维码
    wxloginForPC() {
      let redirectURI = location.href;
      const wxApiRedirectURI = `${PASSPORT_SERVER}/wx/client?redirectURI=${redirectURI}`
      //eslint-disable-next-line
      new WxLogin({
        id: 'wx-login-qrCode',
        appid: PC_APPID,
        scope: SCOPE,
        redirect_uri: wxApiRedirectURI,
        href: 'https://cdn.lessonplan.cn/Public/CSS/wx-login-style(white).css',
      })
    },
    //账号密码登录
    async login() {
      let msg = '';
      if (!this.account || !this.password) msg = '请输入正确的账号密码';
      if (msg) return this.$message.warning(msg);

      this.logining = true;
      //登录
      let jres = await this.$api.classMessage.login({ username: this.account, password: this.password });
      this.logining = false;
      if (jres.statusCode != 200) return this.$message.warning(jres.message);

      window.localStorage.setItem(LESSONPLAY_TOKEN, jres.data.token);
      let user = await this.$api.classMessage.getStudent({ userGuid: jres.data.userGuid }).then(res => res.data);

      if (user) {
        user.HeadPhotoPath = headPath(user.HeadPhotoPath);
        user.Name = user.NickName || user.Name;
        user.token = jres.data.token;
        this.user = user;
        this.$store.commit('userInfo', user);
      }

      this.$message.success('登陆成功');
      this.getClassOfUser();
    },
    //退出
    logout() {
      this.$confirm('确定要返回重新登录吗? ', () => {
        let token = window.localStorage.getItem(LESSONPLAY_TOKEN);
        window.localStorage.removeItem(LESSONPLAY_TOKEN);
        location.href = `${PASSPORT_CLIENT_SERVER}/auth/logout?token=${token}&redirectURI=${ONLINE_URL}&isTourist=true`;
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "./login.scss";
</style>